<template>
  <card-collapsable
    headerClass="cyan darken-1 white--text"
    dialogClass="auctioneer"
    :dialogProp="dialog"
  >
    <!-- :collapsed="collapsed" -->

    <!-- always visible -->
    <template #visible>
      <progress-countdown
        v-show="adminSceglie ? false : asta_settings.timeout_c"
        ref="timer_chooser"
        name="auctioneer"
        :time="adminSceglie ? 0 : asta_settings.timeout_c"
        @timeover="timeoverChooser"
      ></progress-countdown>
      <v-icon v-if="adminSceglie" class="white--text">groups</v-icon>
    </template>

    <!-- card-title -->
    <template #title>
      {{
        mode_assegna
          ? "Scegli calciatore da assegnare"
          : "Scegli calciatore da mettere all'asta"
      }}
    </template>

    <!-- card-body-->
    <template #body>
      <si-sta-facendo-asta-per></si-sta-facendo-asta-per>
      <div class="svincolati-wrapper">
        <asta-svincolati
          ref="asta_svincolati"
          :selected="selectCalciatore"
          :ruoliAllowed="ruoli_da_chiamare"
          :squadre="squadre_escluse"
          :maxQuotazione="maxQuotazione"
          showInformazioni
          :dialogParent="dialog"
          ripple
        ></asta-svincolati>
      </div>
    </template>

    <!-- card-actions -->
    <template #actions v-if="showPasso">
      <v-card-actions class="justify-end">
        <v-btn depressed rounded @click="passo()" class="cyan white--text">
          <v-icon small left>airline_stops</v-icon> Passa
        </v-btn>
      </v-card-actions>
    </template>
  </card-collapsable>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";

import mixins from "../../js/mixins";
import toast from "../../js/toast";

import Vuex from "vuex";
import AstaSvincolati from "../AstaSvincolati";
import ProgressCountdown from "../common/ProgressCountdown";
import CardCollapsable from "../common/CardCollapsable";
import SiStaFacendoAstaPer from "../common/SiStaFacendoAstaPer";

export default {
  mixins: [mixins, toast],
  components: {
    AstaSvincolati,
    ProgressCountdown,
    CardCollapsable,
    SiStaFacendoAstaPer,
  },
  data() {
    return {
      // dialog: false,
      action: false,
    };
  },

  mounted() {
    console.log("--> AstaAuctioneer ready.");
    // to add draggable: https://github.com/vuetifyjs/vuetify/issues/4058
  },
  destroyed() {
    console.log("<-- AstaAuctioneer destroyed.");
  },
  watch: {
    dialog(val) {
      if (val) {
        this.startTimer();
      } else {
        this.action = false;
        this.stopTimer();
      }
    },
  },
  methods: {
    passo() {
      this.action = true;
      const next_squadra_id = Helpers.findNextSquadraIdAsChooser(
        this.asta_choosers,
        this.user_uid
      );
      if (next_squadra_id) {
        db.setChooser(next_squadra_id);
      }
    },
    selectCalciatore: function (id) {
      if (id) {
        this.action = true;

        // 1) salva calciatoreInAsta su db
        let promise = db
          .setCalciatoreInAsta(id)
          .then(this.astaLogCalciatoreInAsta(id, this.user_uid))
          .then(this.wait(50)); // serve in casi limite per evitare che il log dell'assegnazione sia + veloce di questo
        // 2) inizia round
        if (this.mode_poker || this.mode_selvaggia || this.mode_bustachiusa) {
          let asta_mode = this.asta_settings.mode;
          promise.then(db.initRound(id, asta_mode)).then(() => {
            if (this.mode_bustachiusa) {
              db.setStep({ type: Constants.ROUND_STEP.OFFERTE });
            }
          });
        }
      } else {
        // mi sa che questo pezzo viene chiamato solo il timeout per scegliere finisce
        // e il sistema nn ha potuto prendere nessuno automaticamente
        // perchè la lista in quel momento era su un ruolo vuoto (to be checked)
        this.errorToast("Errore", "Nessun calciatore selezionato");
        setTimeout(() => {
          if (this.mode_poker || this.mode_selvaggia) {
            if (
              this.asta_settings.ch_mode === Constants.CHOOSER_MODE.MANUAL ||
              this.asta_settings.ch_mode === Constants.CHOOSER_MODE.MANUAL_PASSO
            ) {
              const next_squadra_id = Helpers.findNextSquadraIdAsChooser(
                this.asta_choosers,
                this.user_uid
              );
              if (next_squadra_id) {
                db.setChooser(next_squadra_id);
              }
            } else if (
              this.asta_settings.ch_mode === Constants.CHOOSER_MODE.ADMIN
            ) {
              db.setChooser(this.adminUid);
            }
          } else if (this.mode_assegna) {
            db.setChooser(this.adminUid);
          }
        }, 2000);
      }
    },
    startTimer() {
      this.$refs["timer_chooser"].start();
    },
    stopTimer() {
      this.$refs["timer_chooser"].stop();
    },
    timeoverChooser() {
      // GIOCATORE HA SCELTO
      if (this.action) return;
      // SCEGLI PRIMO CON QUOTAZIONE PIU ALTA
      if (this.asta_settings.ch_mode === Constants.CHOOSER_MODE.MANUAL) {
        this.selectCalciatore(this.$refs["asta_svincolati"].primoSvincolato());
      } else if (
        this.asta_settings.ch_mode === Constants.CHOOSER_MODE.MANUAL_PASSO
      ) {
        this.passo();
      }
    },
    acquistiPerClub() {
      return this.squadra(this.user_uid).acquistiPerClub;
    },
  },
  computed: {
    dialog() {
      return this.staScegliendo(this.user_uid);
    },
    adminSceglie() {
      return (
        this.mode_assegna ||
        this.asta_settings.ch_mode == Constants.CHOOSER_MODE.ADMIN
      );
    },
    // acquisti() {
    //   return this.squadra(this.user_uid)
    //     ? this.squadra(this.user_uid).acquisti
    //     : null;
    // },
    maxQuotazione() {
      return this.asta_settings.base_asta == Constants.BASE_ASTA.QUOTAZIONE &&
        this.asta_settings.offerta_auto
        ? this.squadra(this.user_uid)
          ? this.squadra(this.user_uid).max_offerta
          : 0
        : 0;
    },
    showPasso() {
      return (
        !this.mode_assegna &&
        this.asta_settings.ch_mode == Constants.CHOOSER_MODE.MANUAL_PASSO
      );
    },
    squadre_escluse() {
      let squadre =
        !this.adminSceglie &&
        this.squadra(this.user_uid) &&
        this.asta_info.lega.limitRosaPerClub?.perClubPerRuolo?.active == 1
          ? _.keys(
              _.pickBy(
                this.acquistiPerClub(),
                function (value) {
                  return (
                    value >=
                    parseInt(
                      this.asta_info.lega.limitRosaPerClub?.perClubPerRuolo
                        .valore
                    )
                  );
                }.bind(this)
              )
            )
          : [];

      return squadre;
    },
    ruoli_da_chiamare() {
      // - Se è sempre admin a scegliere (modalita Assegna o in Impostazioni)
      // - Se non c'è offerta contestuale
      //      => vede sempre tutti i ruoli
      //   altrimenti
      //      => si eliminano i ruoli completati da chi sta chiamando
      // let squadra_id = this.user_uid;
      const squadra = this.squadra(this.user_uid);
      let output = [];
      if (squadra) {
        for (const ruolo of Object.values(Constants.RUOLI_NEW)) {
          const ruolo_id = ruolo.ruolo_id;
          const ruolo_da_chiamare = this.asta_settings.ruolo_da_chiamare;
          if (
            ruolo_da_chiamare == Constants.RUOLO_DA_CHIAMARE.QUALUNQUE ||
            ruolo_da_chiamare == ruolo_id
          ) {
            if (
              this.adminSceglie ||
              this.asta_settings.offerta_auto == 0 ||
              this.asta_info.lega.nRuoli.op == "illimitati" ||
              this.asta_info.lega.nRuoli.op == ">=" ||
              !squadra.isRuoloCompleto[ruolo_id]
              // this.acquistiPerRuolo(ruolo_id, squadra_id) <
              //   this.asta_info.lega.nRuoli[ruolo.n]
            ) {
              output.push(ruolo_id);
            }
          }
        }
      }
      return output;
    },
    ...Vuex.mapGetters([
      "calciatori",
      "svincolati_ids",
      "migliore_offerta",
      "tot_squadre",
      "is_mobile",
      "selected_tab",
      "asta_choosers",
    ]),
  },
};
</script>
<style lang="scss" scoped>
.svincolati-wrapper {
  background-color: var(--v-navy-base);
}
</style>
